export enum GettingStartedEventType {
  Click = 'click'
}
